var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "d-flex flex-nowrap" },
    [
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$vuetify.breakpoint.xs,
              expression: "$vuetify.breakpoint.xs",
            },
          ],
          staticClass: "mr-2",
          attrs: { id: "showSearch" },
          on: { click: _vm.showSearch },
        },
        [_c("v-icon", [_vm._v("mdi-magnify")])],
        1
      ),
      _c("v-text-field", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showSearchMobile || !_vm.$vuetify.breakpoint.xs,
            expression: "showSearchMobile || !$vuetify.breakpoint.xs",
          },
        ],
        ref: "search",
        class: _vm.$vuetify.breakpoint.xs
          ? "overtake-bar mx-2"
          : "regular-bar mx-2",
        attrs: {
          flat: "",
          "hide-details": "",
          dense: "",
          solo: "",
          "prepend-inner-icon": "mdi-magnify",
          "append-icon": "mdi-help-circle-outline",
          label: "Search",
          clearable: "",
        },
        on: {
          input: function ($event) {
            _vm.isTyping = true
          },
          "click:clear": function ($event) {
            _vm.searchTerm = ""
          },
          "click:append": function ($event) {
            _vm.showSearchHelp = true
          },
          blur: function ($event) {
            _vm.showSearchMobile = false
          },
        },
        model: {
          value: _vm.searchTerm,
          callback: function ($$v) {
            _vm.searchTerm = $$v
          },
          expression: "searchTerm",
        },
      }),
      _c("SearchHelpModal", {
        staticStyle: { display: "none" },
        attrs: { visible: _vm.showSearchHelp },
        on: {
          "close-modal": function ($event) {
            _vm.showSearchHelp = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }